import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import { API_PATH } from '../../../Constant/constants';

const AddMedicine = () => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    unitPrice: '',
    expiryDate: '',
    manufacturer: '',
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const token = localStorage.getItem('authToken');
    try {
      await axios.post(`${API_PATH}/medicines`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
  
      alert('✅ Medicine added successfully!');
      setFormData({
        name: '',
        description: '',
        unitPrice: '',
        expiryDate: '',
        manufacturer: '',
      });
  
      // 🔁 Navigate to list page
      navigate('/admin/home/medicines/list');
  
    } catch (error) {
      console.error('Error adding medicine:', error);
      alert('❌ Failed to add medicine');
    }
  };
  

  return (
    <div className="appointment-table">
      <div className="table-header">
    <div className="container mt-4">
      <h3>Add Medicine</h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Name</label>
          <input name="name" value={formData.name} onChange={handleChange} className="form-control" required />
        </div>
        <div className="mb-3">
          <label>Description</label>
          <input name="description" value={formData.description} onChange={handleChange} className="form-control" />
        </div>
        <div className="mb-3">
          <label>Unit Price</label>
          <input name="unitPrice" type="number" step="0.01" value={formData.unitPrice} onChange={handleChange} className="form-control" required />
        </div>
        <div className="mb-3">
          <label>Expiry Date</label>
          <input name="expiryDate" type="date" value={formData.expiryDate} onChange={handleChange} className="form-control" required />
        </div>
        <div className="mb-3">
          <label>Manufacturer</label>
          <input name="manufacturer" value={formData.manufacturer} onChange={handleChange} className="form-control" required />
        </div>
        <button className="btn btn-primary">Submit</button>
      </form>
    </div>
    </div>
    </div>
  );
};

export default AddMedicine;
